/**
 * LIVEPULS-Wortmarke im Style von https://livepuls.de/.
 *  - "LIVE" weiß
 *  - "PULS" Gradient magenta → cyan
 *  - italic, schwarzer Schnitt, eng laufend
 *
 * Größen-Varianten über `size`. Für die Panel-Kopfzeile `size="sm"`.
 */
type Size = 'xs' | 'sm' | 'md' | 'lg';

const SIZE_CLASS: Record<Size, string> = {
  xs: 'text-sm',
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-3xl',
};

export function BrandLogo({
  size = 'md',
  className = '',
}: {
  size?: Size;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={[
        'font-black italic tracking-tighter leading-none select-none',
        SIZE_CLASS[size],
        className,
      ].join(' ')}
    >
      <span className="text-white">LIVE</span>
      <span
        className="text-transparent bg-clip-text"
        style={{
          backgroundImage: 'linear-gradient(90deg, #ff0099 0%, #00f2ff 100%)',
        }}
      >
        PULS
      </span>
    </span>
  );
}
